import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useSelector, useDispatch } from 'react-redux';
import { Box, SystemNotification, Icon } from '@blueprint/ui';
import { serverError } from '../../actions/index';

const NotificationContainer = styled(Box)`
    top: 10%;
    position: fixed;
    z-index: 50;
    transition: 4s;
    transition-timing-function: ease;
    right: ${({ hidden }) => (hidden ? '-100%' : '0')};
`;

const clearError = (dispatch) => {
    let data = {
        status: null,
        statusText: null,
    };
    dispatch(serverError(data));
};

const onClose = (dispatch, setHidden) => {
    clearError(dispatch);
    setHidden(true);
};

const ServerErrorLabel = () => {
    const dispatch = useDispatch();
    const reduxState = useSelector((state) => state.beneDetails.serverError);
    const [hidden, setHidden] = useState(true);

    useEffect(() => {
        if (reduxState.status) {
            console.log('Making Visible');
            setHidden(false);
        }
    }, [reduxState]);

    return (
        <NotificationContainer hidden={hidden} isRemovable={true}>
            <SystemNotification
                title={reduxState.status}
                variant='error'
                onClose={() => {
                    onClose(dispatch, setHidden);
                }}
            >
                {reduxState.statusText}
            </SystemNotification>
        </NotificationContainer>
    );
};

export default ServerErrorLabel;
